module.exports = __webpack_public_path__ + "img/bg-1-black.11c08d6f.png";